import React from 'react'
import CDropdownItem from './CDropdownItem'

//component - CoreUI / CDropdownDivider

const CDropdownDivider = props => {

  return (
    <CDropdownItem {...props} divider/>
  )
}

export default CDropdownDivider